import ApiClient from "./ApiClient";

/**
 * 店舗別売上管理データの取得
 */
export const getStoreSalesReportData = async (params: {
  orgCode: string;
  targetDateFrom: string;
  targetDateTo: string;
  categoryAry?: string[];
  layoutId: string;
  loginStaffCode: string;
  functionType: number;
  monthlyComparePrevYear: number;
}): Promise<any> => {
  // 他のAPIに合わせてcompanyCodeをセッションから取得
  const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";

  const query = {
    orgCode: params.orgCode,
    targetDateFrom: params.targetDateFrom,
    targetDateTo: params.targetDateTo,
    layoutId: params.layoutId,
    loginStaffCode: params.loginStaffCode,
    functionType: String(params.functionType),
    monthlyComparePrevYear: String(params.monthlyComparePrevYear)
  };

  if (params.categoryAry && params.categoryAry.length > 0) {
    // @ts-ignore
    query.categoryAry = params.categoryAry.join(",");
  }

  const response = await ApiClient.get(
    `/v2/sales/list/standard/custom/data/${companyCode}`,
    {},
    query
  );

  return response.data;
};

export default { getStoreSalesReportData };
